export default __webpack_public_path__ + "static/media/Flag_of_Tonga.e0b65f04.svg";